@if (element().copii) {
  <button type="button" class="nav-link" [class.nav-link-contine-curent]="contineRutaCurenta"
    [style.--nivel]="nivel()" [attr.aria-expanded]="deschis" (click)="comuta()" matRipple>
    @if (element().icon) {
      <mat-icon class="nav-icon">{{element().icon}}</mat-icon>
    }
    <span class="nav-titlu">{{element().titlu}}</span>
    <mat-icon class="nav-sageata" [class.nav-sageata-deschis]="deschis">expand_more</mat-icon>
  </button>
  <div class="nav-copii" [class.nav-copii-deschis]="deschis" [attr.inert]="deschis ? null : ''">
    <div class="nav-copii-interior">
      @for (copil of element().copii; track copil.id) {
        <app-nav-element [element]="copil" [nivel]="nivel() + 1" />
      }
    </div>
  </div>
} @else {
  <a class="nav-link" [routerLink]="element().url" routerLinkActive="nav-link-curent" ariaCurrentWhenActive="page"
    [style.--nivel]="nivel()" matRipple>
    @if (element().icon) {
      <mat-icon class="nav-icon">{{element().icon}}</mat-icon>
    }
    <span class="nav-titlu">{{element().titlu}}</span>
  </a>
}
